<script setup lang="ts">
import OrdersList from '~/components/OrdersList.vue';
import { CartsV2CartState } from '@ds/marketplace-ui/orderList';
</script>

<template>
  <div class="mp-container">
    <OrdersList
      :is-seller="false"
      :show-draft-state="true"
      :default-state="CartsV2CartState.PENDING"
    />
  </div>
</template>

<style scoped lang="scss">
@use '/assets/scss/variables' as variables;

.mp-container {
  width: 100%;
}

@media (max-width: variables.$screen-xs-max) {
  .mp-container {
    margin: 0;
  }
}
</style>
